import React,  { useState } from "react";
import { Carousel } from "react-responsive-carousel";
import { Formik } from "formik";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
  Portlet,
  PortletBody,
//  PortletHeader,
//  PortletHeaderToolbar
} from "../partials/content/Portlet";

import { getBanners,getFile
} from "../crud/auth.crud";

import Linkify from 'react-linkify';

import '../pages/home/carousel.css'

function Banner(props) {
  

 const [intervalz,setIntervalz] = useState(1000);
 const [bannerMessage,setBannerMessage] = useState(null);

 const onChange = (index, item) => {
    console.log("delay:::",new Date() + "---" +item.props["data-interval"]);
    //this.setState({intervalz:parseInt(item.props["data-interval"]) * 1000});
    setIntervalz(parseInt(item.props["data-interval"]) * 1000);
  };


  const [banner,setBanner] =useState(null);
  
  React.useEffect(() => {
        const fetchBanner = async () => {
            try {
                let banners = [];
                const response = await getBanners();
                banners = response.data;
                let i =0;
                let intervalz=1000;
                banners.map(async (banner,index)=>{
                 if(banner.bannerType === "image")
                 {
                  if(parseInt(i)===0) intervalz = banner.displayTime;
                   const url = await getFile("id",banner.imagePath);
                   banners[index] =  {...banners[index],imagePath:  url.data.downloadUrl};
                 }

              })
              console.log("final:::",banners);
              //setIntervalz(parseInt(intervalz));
              setBanner(banners);

              //setBanner(banners);
            } catch (e) {
                console.log(e);
                
            }
        };
        fetchBanner();
    }, []);


   



  return (
        <>
        
        {bannerMessage!==null &&
        <div className="row">
          <div className="col">
            <div className="alert alert-light alert-elevate fade show" role="alert">
             
                <div className="alert-text" style={{'font-size':'20px', 'font-weight': 'bold'}}>
                 
                   <Linkify properties={{target: '_blank', style: {color: 'blue', fontWeight: 'bold'}}}> {bannerMessage}</Linkify>

                </div>
              </div>
           </div>
        </div>
       }

      {banner !==null && banner.length>0 && 
      <div className="row">
          <div className="col">
             <Portlet className="kt-portlet--border-bottom-brand">
                <PortletBody fluid={true}>
              
              <Carousel
                onChange={onChange}
                autoPlay={true}
                interval={intervalz}
                infiniteLoop={true}
                showArrows={false}
                showStatus={true}
                showIndicators={false}
                stopOnHover={false}
                swipeable={false}
                useKeyboardArrows={false}
                showThumbs={false}                 
              >
              <div key={'a'} data-interval={1}>
                 <h1><Linkify properties={{target: '_blank', style: {color: 'blue', fontWeight: 'bold'}}}> {'Welcome to My Patient Exchange'}</Linkify></h1>
              </div>
              {banner.map((b,index)=>{
               return <div key={index} data-interval={b.displayTime}>
                  {b.bannerType==="image" && <img alt="" src={b.imagePath} />}
                  {b.bannerType==="text" && <h1><Linkify properties={{target: '_blank', style: {color: 'blue', fontWeight: 'bold'}}}> {b.message}</Linkify></h1>}
                </div>
              })}

            </Carousel>
            </PortletBody>
          </Portlet>
        </div>
      </div>
          }
            
          
           
            
           
    

      
      
        
    </>
      
  );
}


export default Banner;
